import React from 'react';

import maxBountyLogoDesktop from '../../assets/images/MaxBounty_Horizontal_White.png';

import './Logo.css';

const logo = () => (
    <React.Fragment>
        <div className="logo">
            <img src={maxBountyLogoDesktop} alt="MaxBounty" />
        </div>
    </React.Fragment>
);

export default logo;